(() => {
  const enhanceCatalog = () => {
    const seen = new Set();
    const counts = new Map();
    document.querySelectorAll('.aq-curated__item[data-aq-product-id]').forEach(item => {
      const id = item.dataset.aqProductId;
      const source = item.closest('section')?.getAttribute('aria-labelledby') + ':' + item.dataset.aqSource;
      const count = counts.get(source) || 0;
      const hide = seen.has(id) || count >= Number(item.dataset.aqLimit || 8);
      if (item.hidden !== hide) item.hidden = hide;
      if (!hide) { seen.add(id); counts.set(source, count + 1); }
    });
    document.querySelectorAll('a[href*="/collections/"]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || url.searchParams.has('filter.v.availability')) return;
      if (!link.closest('.aq-collection-shortcuts') && link.closest('.header,.menu-drawer,.aq-curated,.aq-circles')) {
        url.searchParams.set('filter.v.availability', '1');
        link.href = url.toString();
      }
    });
    document.querySelectorAll('.aq-curated__grid').forEach(grid => {
      if (grid.dataset.aqDragReady) return;
      grid.dataset.aqDragReady = 'true';
      let drag = null;
      let ignoreClickUntil = 0;
      grid.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { id: event.pointerId, x: event.clientX, scroll: grid.scrollLeft, moved: false };
      });
      grid.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 6) return;
        if (!drag.moved) { drag.moved = true; grid.setPointerCapture(event.pointerId); }
        event.preventDefault();
        grid.scrollLeft = drag.scroll - distance;
      });
      const release = () => {
        if (drag?.moved) ignoreClickUntil = Date.now() + 300;
        drag = null;
      };
      grid.addEventListener('pointerup', release);
      grid.addEventListener('pointercancel', release);
      grid.addEventListener('lostpointercapture', release);
      grid.addEventListener('dragstart', event => event.preventDefault());
      grid.addEventListener('click', event => {
        if (Date.now() < ignoreClickUntil) { event.preventDefault(); event.stopPropagation(); }
      }, true);
    });
  };
  const init = () => {
    enhanceCatalog();
    document.querySelectorAll('.aq-product-luxury').forEach(root => {
      if (root.dataset.aqMobileReady) return;
      root.dataset.aqMobileReady = 'true';
      const bar = document.getElementById('AqMobileBuy');
      const button = bar?.querySelector('button');
      const price = bar?.querySelector('.aq-mobile-buy__price');
      const mobile = matchMedia('(max-width: 749px)');
      const mainButton = () => root.querySelector('.product-form__submit');
      const enhanceCard = () => {
        const box = root.querySelector('#ymq-box');
        if (!box) return;
        const fields = [...box.querySelectorAll('.ymq-options-box')];
        const card = fields.find(field => /كرت.*اهداء|كرت.*إهداء/.test(field.dataset.label || ''));
        const wrap = fields.find(field => /تغليف/.test(field.dataset.label || ''));
        if (!card || !wrap || card.querySelector('[required]') || /required/.test(card.dataset.validate || '')) return;
        const selected = [...wrap.querySelectorAll('input:checked,option:checked')];
        const enabled = selected.some(input => /نعم|مع تغليف|Yes/i.test(input.value));
        const hasMessage = [...card.querySelectorAll('input:not([type="hidden"]),textarea')].some(input => input.value.trim());
        const hide = !enabled && !hasMessage;
        if (card.classList.contains('aq-card-message-hidden') !== hide) card.classList.toggle('aq-card-message-hidden', hide);
      };
      const sync = () => {
        enhanceCard();
        if (!bar || !button) return;
        const main = mainButton();
        const priceNode = root.querySelector('[id^="price-"] .price-item--sale') || root.querySelector('[id^="price-"] .price-item--regular');
        const value = priceNode?.textContent.trim() || '';
        if (price.textContent !== value) price.textContent = value;
        const label = main?.querySelector('span')?.textContent.trim() || main?.textContent.trim();
        if (label && button.textContent !== label) button.textContent = label;
        button.disabled = !main || main.disabled || main.getAttribute('aria-disabled') === 'true';
        const rect = main?.getBoundingClientRect();
        const mainVisible = rect && rect.top >= 0 && rect.bottom <= innerHeight;
        const overlay = document.querySelector('cart-drawer.active,menu-drawer details[open],product-modal[open],.shopify-pc__prefs__dialog[open]');
        bar.hidden = !mobile.matches || !main || !!mainVisible || !!overlay;
      };
      button?.addEventListener('click', () => {
        const main = mainButton();
        if (!main || main.disabled) return;
        const gift = root.querySelector('.aq-luxury-gift');
        const missing = [...root.querySelectorAll('#ymq-box .ymq-options-box')].find(field => {
          if (getComputedStyle(field).display === 'none') return false;
          const rules = field.dataset.validate || '';
          if (!/min_s:1|required/.test(rules)) return false;
          const inputs = [...field.querySelectorAll('input:not([type="hidden"]),select,textarea')].filter(input => !input.disabled);
          if (!inputs.length) return false;
          return !inputs.some(input => /checkbox|radio/.test(input.type) ? input.checked : input.value.trim());
        });
        if (missing) {
          if (gift) gift.open = true;
          missing.closest('.aq-luxury-note')?.setAttribute('open', '');
          missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (gift) gift.open = true;
        root.querySelectorAll('.aq-luxury-note').forEach(note => note.open = true);
        main.click();
      });
      let pending = false;
      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; sync(); });
      };
      new MutationObserver(schedule).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'style'] });
      root.addEventListener('change', schedule);
      document.addEventListener('scroll', schedule, { passive: true });
      mobile.addEventListener('change', schedule);
      window.addEventListener('resize', schedule, { passive: true });
      new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'], subtree: true });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
